




























import { Vue, Component } from 'vue-property-decorator'
import CatalogHeader from '@/modules/catalog/components/CatalogHeader'
import WalletTransactions from '@/modules/payment/components/WalletTransactions'

@Component({
  components: {
    CatalogHeader,
    WalletTransactions
  }
})
export default class PaymentTransactions extends Vue {
  title = this.$t('Transactions.Title')
  tab: number = 0
}
